import React, { useState } from "react";
import "../styles/Form.css";
import Modal from "./Modal";

const Form = () => {
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      <section id="contact" className="form">
        <h4 className="form-title"> Ready to Learn?</h4>
        <button className="form-button" onClick={() => setShowModal(true)}>
          Enquire Now
        </button>
      </section>
      <Modal show={showModal} onClose={() => setShowModal(false)} />
    </>
  );
};

export default Form;
